import React, { memo, useState } from 'react';

import Link from 'next/link';
import { AiOutlineRise } from 'react-icons/ai';
import { BiArrowBack } from 'react-icons/bi';
import { BsClock } from 'react-icons/bs';
import { HiArrowNarrowRight, HiFilter } from 'react-icons/hi';
import { IoDiamond } from 'react-icons/io5';
import { MdAssignmentAdd } from 'react-icons/md';
import { useWindowSize } from 'usehooks-ts';

import { SHOW_ALL_ADS } from '@/lib/constants';
import { useListingsFilterSort } from '@/lib/hooks/useInfiniteAdsList';
import BoostCard from '@/modules/boost/components/BoostCard';
import { IListingItem, ListingState } from '@/modules/core/types';
import AdList from '@/tayara-kit/AdList';
import Divider, { Orientation } from '@/tayara-kit/Divider';
import { TkArrowUp, TkCard } from '@/tayara-kit/icons';
import Select from '@/tayara-kit/Select';
import Text from '@/tayara-kit/Text';

import ClassicBoostPlan from './ClassicBoostPlan';
import AlaUneBoostPlan from '../AlaUneBoostPlan';

export interface MyListingsProps {
  adlist: IListingItem[];

  loadMoreAds: () => {};
  countAds: number;
  balance: number;
}
function MyListings({
  adlist,
  loadMoreAds,
  countAds,
  balance,
}: MyListingsProps) {
  const {
    // SORT_OPTIONS,
    FILTER_OPTIONS,
    // setSort,
    setFilterState,
  } = useListingsFilterSort();
  const [showSelction, setShowSelction] = useState(false);
  const [showAdList, setShowAdList] = useState(true);
  const windowSize = useWindowSize();

  // Function to log selected ads
  const handelClickMultilpleBoost = () => {
    setShowAdList(!showAdList);
    setShowSelction(showAdList);
  };

  return (
    <>
      <div className="w-full flex  md:flex-col xl:flex-row flex-wrap gap-y-6 items-center justify-center lg:justify-between">
        <div className="flex flex-wrap  flex-col xl:flex-row items-center gap-2 ">
          <Text
            as="h2"
            text={`Mes annonces`}
            className="text-2xl text-gray-600 font-bold "
          />
          <Text
            text={`(${countAds} annonces trouvées dans votre liste)`}
            as="data"
            className="block  mt-1 text-sm lg:text-base font-bold text-info"
          />
        </div>
        <div className="w-full xl:w-fit gap-4 flex flex-wrap xl:flex-nowrap justify-center md:justify-between items-center">
          {showAdList ? (
            <button
              onClick={handelClickMultilpleBoost}
              className="flex items-center border-[1px] text-white bg-primary hover:bg-primary-focus rounded-lg  px-4"
            >
              <MdAssignmentAdd className="ml-2" size={22} />
              <AiOutlineRise
                className="relative  mt-1 -top-1 right-2"
                size={18}
              />
              <h3 className="flex items-center p-[10px]  text-xs font-semibold w-max">
                Planifier mes boosts
              </h3>
            </button>
          ) : (
            <button
              onClick={handelClickMultilpleBoost}
              className="flex items-center border-[1px] text-white bg-primary hover:bg-primary-focus rounded-lg  px-4"
            >
              <BiArrowBack size={18} className="ml-2" />
              <h3 className="flex items-center p-[10px]  text-xs font-semibold w-max">
                Retourner à mes annonces
              </h3>
            </button>
          )}
          {/* <Select
            className="rounded-full select-sm w-[160px] max-w-full mr-2"
            displayLabel="Trier par"
            options={SORT_OPTIONS}
            defaultValue="creationtimestamp:desc"
            onChange={(e) => {
              setSort(e.target.value);
            }}
          /> */}

          {showAdList && (
            <>
              {windowSize.width > 1200 && (
                <Divider
                  orientation={Orientation.VERTICAL}
                  className={'h-5 '}
                />
              )}

              <Select
                className="select-sm w-full xl:w-fit h-[40px] pl-10 max-w-full max-h-full select rounded-md focus:outline-none border-1 border-gray-300 bg-gray-200/70 text-xs !text-gray-600 hover:!text-gray-700 !font-bold"
                displayLabel="Filtrer par"
                options={FILTER_OPTIONS}
                defaultValue="show-all"
                icon={<HiFilter size={20} className="text-gray-600" />}
                onChange={(e) => {
                  const newVal: ListingState | number =
                    Number(e.target.value) === SHOW_ALL_ADS
                      ? SHOW_ALL_ADS
                      : Number(e.target.value);
                  setFilterState(newVal);
                }}
              />
            </>
          )}
        </div>
      </div>
      {showSelction && !showAdList ? (
        <div className="flex flex-col w-full items-center justify-center m-6 p-6 mx-auto rounded-3xl border-[1px] border-neutral-100">
          <BsClock size={52} className={'text-gray-600 mb-2'} />
          <Text
            as="h2"
            text={`Planifier mes boosts`}
            className="text-xl text-gray-600 font-semibold "
          />{' '}
          <Text
            as="p"
            text={`Choisissez le type de boost que vous souhaitez planifier`}
            className="text-sm lg:text-lg text-center text-gray-600 font-light mt-2 "
          />
          <div className="mt-10 mb-6">
            <div className="flex flex-col flex-wrap justify-center gap-3">
              <div className="flex flex-wrap justify-center gap-3">
                <BoostCard
                  action={handelClickMultilpleBoost}
                  renderAction={
                    <ClassicBoostPlan
                      adListData={adlist}
                      loadMoreAds={loadMoreAds}
                      showSelction={showSelction}
                      setShowAdList={setShowAdList}
                      setShowSelction={setShowSelction}
                      balance={balance}
                      title="Planifier mes boosts classiques"
                      buttonElement={
                        <button
                          className="mb-0 mt-auto uppercase tracking-[0.2rem] font-normal text-2xs border-2 border-gray-200 bg-white text-gray-700 rounded-md h-10 group-hover:text-white group-hover:font-medium
              group-hover:bg-blue-500 hover:!bg-red-400 flex items-center gap-2 p-4 justify-center "
                        >
                          <h3 className="flex items-center p-4  text-xs font-semibold w-max">
                            Étape suivante
                          </h3>
                          <HiArrowNarrowRight
                            className="group-hover:animate-go-right"
                            size={14}
                          />
                        </button>
                      }
                    />
                  }
                  title="Boosts classique"
                  description="Choisissez la date et sélectionnez les annonces à planifier pour les booster.
"
                  className=""
                  figure={
                    <div className="h-[155px] w-[155px] p-3 flex mx-auto items-center justify-center flex-col">
                      <div className="w-full">
                        <TkArrowUp
                          className="mx-auto mb-[-14%] text-gray-600 group-hover:text-blue-500"
                          size="49%"
                        />
                        {/* Cards */}
                        <div className="flex gap-2 text-stone-200">
                          <TkCard className="w-10 h-16" size={'100%'} />
                          <TkCard
                            className="w-10 h-14 mt-[20%]"
                            size={'100%'}
                          />
                          <TkCard className="w-10 h-16" size={'100%'} />
                        </div>
                      </div>
                    </div>
                  }
                />
                <BoostCard
                  action={handelClickMultilpleBoost}
                  title="Boosts à la une"
                  description="Sélectionnez les annonces qui seront poussées en haut de la page."
                  figure={
                    <div className="h-[155px] w-[155px] p-3 flex mx-auto items-center justify-center flex-col">
                      <div className="w-full">
                        <IoDiamond
                          className="mx-auto mb-[-15%] text-gray-600 group-hover:text-blue-500"
                          size="49%"
                        />
                        {/* Cards */}
                        <div className="flex gap-2 text-stone-200 ">
                          <TkCard className="w-10 h-16" size={'100%'} />
                          <TkCard
                            className="w-10 h-14 mt-[20%]"
                            size={'100%'}
                          />
                          <TkCard className="w-10 h-16" size={'100%'} />
                        </div>
                      </div>
                    </div>
                  }
                  renderAction={
                    <AlaUneBoostPlan
                      adListData={adlist}
                      loadMoreAds={loadMoreAds}
                      showSelction={showSelction}
                      setShowSelction={setShowSelction}
                      setShowAdList={setShowAdList}
                      balance={balance}
                      title="Sélectionnez mes boosts à la une"
                      buttonElement={
                        <button
                          className="mb-0 mt-auto uppercase tracking-[0.2rem] font-normal text-2xs border-2 border-gray-200 bg-white text-gray-700 rounded-md h-10 group-hover:text-white group-hover:font-medium
              group-hover:bg-blue-500 hover:!bg-red-400 flex items-center gap-2 p-4 justify-center "
                        >
                          <h3 className="flex items-center p-4  text-xs font-semibold w-max">
                            Étape suivante
                          </h3>
                          <HiArrowNarrowRight
                            className="group-hover:animate-go-right"
                            size={14}
                          />
                        </button>
                      }
                    />
                  }
                />
              </div>
              <Link
                href={`/services`}
                passHref
                target={'_blank'}
                className="w-fit mx-auto my-4 font-normal  text-gray-800  h-10  
               flex items-center gap-2 p-4 justify-center "
              >
                <h3 className="flex items-center underline  text-base md:font-normal w-fit">
                  En savoir plus sur les boosts
                </h3>
                {/* <HiArrowNarrowRight
                  className="group-hover:animate-go-right"
                  size={14}
                /> */}
              </Link>
            </div>
          </div>
        </div>
      ) : (
        <AdList
          adListData={adlist}
          loadMoreAds={loadMoreAds}
          showSelction={showSelction}
          showAdList={showAdList}
          setShowSelction={setShowSelction}
          balance={balance}
        />
      )}
    </>
  );
}

export default memo(MyListings);
